import React, { Component } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import XLSX from 'xlsx';

export class UploadResults extends Component
{
  
    formatIncidentData = () =>
    {
      let dataRows = [];
      if (this.props.results.HeaderRow) {
        let firstRow = [];
        this.props.results.HeaderRow.forEach(rowHeading => {
          firstRow.push(rowHeading);
        });
        firstRow.push("Error");

      dataRows.push(firstRow);
      
      var i = 0;
      this.props.results.SkippedIncidents.forEach(incident => {
        let newRow = [];
        incident.forEach(fieldValue => {
          newRow.push(fieldValue);
        });
        newRow.push(this.props.results.SkippedIncidentDetails[i]);
        dataRows.push(newRow);
        i++;
      });
    }

      return dataRows;
    }

    writeCsv = () =>
    {
      const workbook = XLSX.utils.book_new();
      let incidentData = this.formatIncidentData();
      let incidentSheet = XLSX.utils.aoa_to_sheet(incidentData);
      XLSX.utils.book_append_sheet(workbook, incidentSheet, "RejectedRecords");

      XLSX.writeFile(workbook, "RejectedRecords.xlsx");
    }

    componentDidUpdate = (prevProps, prevState) =>
    {
      if (this.props.results && this.props.results !== prevProps.results)
      {
          if (this.props.results.SkippedIncidents && this.props.results.SkippedIncidents.length > 0)
          {
            this.writeCsv();
          }
      }
    }

   render()
   {
       return (!this.props.isVisible) ? (<div></div>) : (
         <Table>
         <TableBody>
          <TableRow>
            <TableCell style={{fontWeight:"bold", whiteSpace: 'nowrap'}}>Records parsed from file:</TableCell>
            <TableCell>{this.props.results.NumberOfParsedRecords}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{fontWeight:"bold", whiteSpace: 'nowrap'}}>New incidents created:</TableCell>
            <TableCell>{this.props.results.NumberOfUploadedIncidents}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell style={{fontWeight:"bold", whiteSpace: 'nowrap'}}>Existing incidents deleted:</TableCell>
            <TableCell>{this.props.results.NumberOfDeletedRecords}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell style={{fontWeight:"bold", whiteSpace: 'nowrap'}}>Number of skipped records:</TableCell>
            <TableCell>{this.props.results.SkippedRecordCount}</TableCell>
          </TableRow>
          { this.props.results.Rejected &&
            <TableRow>
              <TableCell style={{fontWeight:"bold", whiteSpace: 'nowrap'}}>Error:</TableCell>
              <TableCell>{this.props.results.ErrorText}</TableCell>
            </TableRow>
          }
          {this.props.results.SkippedRecordCount > 0 &&
            <TableRow>
              <TableCell style={{fontWeight:"bold", whiteSpace: 'nowrap'}}  colSpan={2}>See downloaded spreadsheet for rejected records and related data issues.</TableCell>
            </TableRow>
          }

           </TableBody>
         </Table>
       );
     }
}

export default UploadResults;
